import * as React from 'react';
import Box from '@mui/material/Box';

export function SnowInHeader() {
    return <Box className="header-snow" sx={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        overflow: 'hidden',
        pointerEvents: 'none',
        zIndex: 0,
        willChange: 'background-position'
    }} />
}
